import { LAYERTYPE, Layer } from "./internal";
import { createFetchError } from "../../infra3d/utils/ajax";
/**
 * @class WFSLayer
 */
export class WFSQGISLayer extends Layer {
    constructor(scene, opt_options) {
        super(scene, opt_options);
        this.type = LAYERTYPE.WFSQGISLAYER;
        const options = opt_options || {};
        this.api = options.api;
        this.coordsdim = 2;
        this.format = options.format || "gml3";
    }
    /**
     * Loads all features within the extent
     * @param extent
     * @param srid
     */
    _loadFeatures_internal(extent, srid) {
        this.api.getFeatures(extent, srid, this.layername, this._applyFilter(), (geojson) => {
            if (this.coordsdim == 2)
                Layer.geojsonRemoveZValues(geojson);
            this.addFeatures(geojson);
        }, (error) => {
            console.warn(error.message);
        });
    }
    /**
     * Creates xml to send to wfs server
     * @param inserts
     * @param updates
     * @param deletions
     * @param cbs
     * @param cbf
     * @private
     */
    _saveFeatures_internal(inserts, updates, deletions, cbs, cbf) {
        const crs = inserts.crs.properties.name;
        this.api.applyEdits(this.layername, crs, inserts, updates, deletions, cbs, (response) => {
            cbf(createFetchError(500, response.message));
        });
    }
    /**
     * Gets all features on this layer
     * @param cbs
     * @param cbf
     * @param options
     * @private
     */
    _exportFeatures_internal(cbs, cbf, options) {
        const countonly = typeof options.countonly === "undefined" ? false : options.countonly;
        const sorters = options.sorters || [];
        let sort_string = "";
        if (sorters.length > 0) {
            sort_string = `${sorters[0].property} ${sorters[0].direction}`;
        }
        this.api.pageFeatures(this.layername, options.start || 0, options.limit || 10000, options.srid || "", this._applyFilter(), sort_string, countonly, (fc, counts) => {
            if (countonly) {
                cbs(counts);
            }
            else {
                cbs(fc);
            }
        }, (error) => {
            cbf(createFetchError(500, error.message));
        });
    }
    _applyFilter() {
        const exp_filters = [];
        for (const filter of this.filters) {
            switch (filter.operator) {
                case "like":
                    exp_filters.push(`"${filter.property}"ILIKE%27%25${filter.value}%25%27`);
                    break;
                case "eq":
                    exp_filters.push(`"${filter.property}"=%27${filter.value}%27`);
                    break;
                case "lt":
                    exp_filters.push(`"${filter.property}"<%27${filter.value}%27`);
                    break;
                case "gt":
                    exp_filters.push(`"${filter.property}">%27${filter.value}%27`);
                    break;
            }
        }
        if (exp_filters.length > 0) {
            return `${exp_filters.join("AND")}`;
        }
        return "";
    }
}
//# sourceMappingURL=wfsqgislayer.js.map